// extracted by css-extract-rspack-plugin
export default {"cls1":"LearningPoints-cls1_62N","cls2":"LearningPoints-cls2_bz2 LearningPoints-cls1_62N"};